import { Error as ErrorIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useRouteError } from 'react-router-dom';

import { Button } from '@/components/Button';
import { devContacts } from '@/configs/devContacts';

import { containerVariants, iconVariants, itemVariants } from './animations';
import { getErrorMessage } from './helper';

import s from './ErrorBoundary.module.scss';

export const ErrorBoundary = () => {
  const error = useRouteError();
  const errorMessage = getErrorMessage(error);

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className={s.wrapper}>
      <motion.div
        className={s.content}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className={s.icon} variants={iconVariants}>
          <ErrorIcon />
        </motion.div>
        <motion.h1 className={s.title} variants={itemVariants}>
          Что-то пошло не так
        </motion.h1>
        <motion.div className={s.description} variants={itemVariants}>
          Произошла ошибка в приложении. За помощью пишите:{' '}
          {devContacts.map((contact, index) => {
            if (contact.showAsSupport) {
              return (
                <span key={contact.name}>
                  <a href={contact.tg} target="_blank" rel="noopener noreferrer">
                    {contact.name}
                  </a>
                  {index < devContacts.length - 1 ? ', ' : ''}
                </span>
              );
            }
          })}
        </motion.div>

        {import.meta.env.DEV && (
          <motion.div className={s['error-details']} variants={itemVariants}>
            <div className={s['error-section']}>
              <div className={s['error-label']}>Сообщение об ошибке:</div>
              <div className={s['error-message']}>{errorMessage}</div>
            </div>
          </motion.div>
        )}

        <motion.div className={s.actions} variants={itemVariants}>
          <Button onClick={handleGoHome} variant="outlined">
            Вернуться на главную
          </Button>
          <Button onClick={handleReload} variant="contained">
            Перезагрузить страницу
          </Button>
        </motion.div>
      </motion.div>
    </div>
  );
};
